/* eslint-disable space-before-function-paren */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isActive: false,
  activeDocumentId: null,
  zoningIntent: null,
  images: [],
  claimId: null,
  valueParams: null,
};

const ocrSlice = createSlice({
  name: 'ocr',
  initialState,
  reducers: {
    openViewer(state, action) {
      state.isActive = true;
      state.claimId = action.payload;
    },

    setImages(state, action) {
      state.images = action.payload;
    },

    closeViewer(state) {
      state.isActive = false;
      state.activeDocumentId = null;
      state.zoningIntent = null;
      state.images = [];
      state.claimId = null;
      state.valueParams = null;
    },

    setActiveDocument(state, action) {
      state.activeDocumentId = action.payload;
    },

    setZoningIntent(state, action) {
      state.zoningIntent = action.payload;
    },

    setClaimId(state, action) {
      state.claimId = action.payload;
    },

    clearZoningIntent(state) {
      state.zoningIntent = null;
    },
    setValueParams(state, action) {
      state.valueParams = action.payload;
    },
  },
});

export const {
  openViewer,
  closeViewer,
  setZoningIntent,
  clearZoningIntent,
  setActiveDocument,
  setImages,
  setClaimId,
  setValueParams,
} = ocrSlice.actions;

export default ocrSlice.reducer;
// Sample OCR coordinate response:
// {
//     "data": {
//         "id": number,
//         "created_at": string,
//         "updated_at": string,
//         "insurance_claim_id": number,
//         "insurance_claim_component_id": number,
//         "file_id": number,
//         "page_number": number,
//         "key": string,
//         "value": string,
//         "bounding_box": {
//             "vertices": [
//                 {
//                     "x": 128,
//                     "y": 616
//                 },
//                 {
//                     "x": 378,
//                     "y": 616
//                 },
//                 {
//                     "x": 378,
//                     "y": 632
//                 },
//                 {
//                     "x": 128,
//                     "y": 632
//                 }
//             ],
//             "normalized_vertices": [
//                 {
//                     "x": 0.07623585313558578,
//                     "y": 0.2586062252521515
//                 },
//                 {
//                     "x": 0.225134015083313,
//                     "y": 0.2586062252521515
//                 },
//                 {
//                     "x": 0.225134015083313,
//                     "y": 0.2653232514858246
//                 },
//                 {
//                     "x": 0.07623585313558578,
//                     "y": 0.2653232514858246
//                 }
//             ]
//         },
//         "confidence": 0.98,
//         "created_by": 2,
//         "updated_by": 2
//     },
//     "message": "success",
//     "meta": {
//         "http_status": 200
//     }
// }
